/**
 * IFRAME 号码走势图 分屏页
 * @param  {[BOOLEAN]} display   	[控制显示还是隐藏]
 * @param  {[FUNCTION]} onHide:   [内部点击的方法]
 * @param  {[STRING]}   url:  		[ifram地址]
 * by  vico 
 */
import React from 'react';
import ReactDOM from 'react-dom';


export default class DragFrame extends React.Component {
	constructor(props) {
	    super(props);
	    this.move = this.move.bind(this);
	    this.onDrangEnd = this.onDrangEnd.bind(this);
	    this.state ={
	    	mask:"none"
	    }
	}

	componentWillReceiveProps(nexProps){
		if (!this.refs.DragBox || !this.refs.dragMask) {return}
		if(this.props.display && !nexProps.display){
			document.removeEventListener("mousemove",this.move);
    		document.removeEventListener("mouseup",this.onDrangEnd);
    		document.querySelector('#componentContainer').style.marginBottom = "0px";
    		ReactDOM.findDOMNode( this.refs.DragBox).style.height = "0px";
    		ReactDOM.findDOMNode( this.refs.dragMask).style.height = "0px";
    		return;
		}
		if (!this.props.display && nexProps.display) {
			document.querySelector('#componentContainer').style.marginBottom = "400px";
			ReactDOM.findDOMNode( this.refs.DragBox) .style.height = "400px";
			ReactDOM.findDOMNode( this.refs.dragMask ).style.height = "400px";
		}
	}

	move(e){
		let _wh = window.screen.availHeight;
		let _height  = (_wh - e.clientY) -69;
		if(_height > 700){
			this.setState({height:"700px"})
			ReactDOM.findDOMNode( this.refs.DragBox).style.height = "700px";
			ReactDOM.findDOMNode( this.refs.dragMask ).style.height = "700px";
			return;
		}
		if(_height  < 300){
			this.setState({height:"300px"})
			ReactDOM.findDOMNode( this.refs.DragBox).style.height = "300px";
			ReactDOM.findDOMNode( this.refs.dragMask ).style.height = "300px";
			return;
		}
		ReactDOM.findDOMNode( this.refs.DragBox).style.height = _height+"px";
		ReactDOM.findDOMNode( this.refs.dragMask ).style.height =_height+"px";
		document.querySelector('#componentContainer').style.marginBottom = _height+"px";
	}

	onDow(e){
		this.setState({mask:"block"})
      	document.addEventListener("mousemove",this.move);
      	document.addEventListener("mouseup",this.onDrangEnd);
    }

    onDrangEnd(e){
    	this.setState({mask:"none"})
    	document.removeEventListener("mousemove",this.move);
    	document.removeEventListener("mouseup",this.onDrangEnd);
    }

	render() {
		const {display, onHide, url} = this.props;
		return (
			<div className="Drag-box" ref="DragBox" style={{display:display?'block':'none'}}>
				<div className="line-drag" 
					onMouseDown={this.onDow.bind(this)} 
					onMouseUp={this.onDrangEnd.bind(this)}
					>
				</div>
				<div className="drag-mask" style={{display:this.state.mask}}></div>
				<div className="btn line-close-btn"  onClick={onHide}>收起</div>
				<iframe  className="Drag-ifm"  id='dragMask' ref="dragMask" src={url}></iframe>
			</div>
		)
	}
}